import React from "react";
import { Wallet, Wrench, MessageSquare } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [Wallet, Wrench, MessageSquare];

export default function WhyUs() {
  const { t } = useI18n();

  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-16 md:py-20 bg-[#080808] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-10 max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#e52620]" />
            <span className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 font-bold font-mono">
              {t.why.eyebrow}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white leading-[0.95] text-balance">
            {t.why.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.why.items.map((it, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="group relative bg-[#0e0e0e] border border-white/10 rounded-xl p-8 hover:border-white/30 transition-colors duration-500"
              >
                <div className="w-12 h-12 rounded-md bg-[#e52620] flex items-center justify-center">
                  <Icon className="w-5 h-5 text-white" strokeWidth={2.25} />
                </div>
                <h3 className="mt-6 text-xl md:text-2xl font-bold text-white tracking-tight">
                  {it.t}
                </h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">{it.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
